import * as firebase from "firebase/app";

import "firebase/auth";
import "firebase/database";

import { getConfig } from "./configs";

const config = getConfig();

const firebaseApp = firebase.initializeApp(config);

// const db = firebase.firestore();
const db = firebase.database();
const auth = firebase.auth();

export { firebaseApp, auth, db as firebaseDB };

(window as any).firebaseApp = firebaseApp;



// WEBPACK FOOTER //
// ./src/firebase/index.ts